<template>
    <FormSearchSelect
        v-bind="$attrs"
        class="FormSelectClient"
        :value="value"
        :label="label"
        :options="activeClients"
        :reduce="client => client.id"
        :getOptionLabel="client => client.name"
        @input="handleInput"
    >
        <template v-if="showCreateOption" #list-header>
            <ButtonIcon icon="plus" class="block" @click="handleCreate">
                Add new
            </ButtonIcon>
        </template>
    </FormSearchSelect>
</template>

<script>
import { mapState } from 'vuex';
import ClientCreateModal from '@/components/modals/ClientCreateModal';

export default {
    name: 'FormSelectClient',
    inheritAttrs: false,

    props: {
        value: { type: Number },
        label: { type: String, default: 'Client' },
        showCreateOption: { type: Boolean, default: false },
    },

    data: () => ({
        initialValue: null,
    }),

    computed: {
        ...mapState('company', ['clients']),

        activeClients() {
            return this.clients.filter((client) => {
                return client.id === this.initialValue ? true : client.isActive;
            });
        },
    },

    beforeMount() {
        this.initialValue = this.value;
    },

    methods: {
        handleInput(clientId) {
            this.$emit('input', clientId);
        },

        handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'prompt_create_client', {
                model_type: 'client',
                model_action: 'create_intent',
            });

            this.$modal.show(ClientCreateModal, {
                onClientCreated: this.handleClientCreated
            });
        },

        handleClientCreated(newClient) {
            this.$emit('input', newClient.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.FormSelectClient {
    .ButtonIcon {
        justify-content: flex-start;
    }
}
</style>
